// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.intention.RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UnifiedLeadInsertIntentionActionRequestWebDto } from '../..';

export const RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Path =
  '/api/web/v1/users/intention/insertAction';

/**
 * No-op; landlord intention is no longer recorded
 */
export const RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction = (
  postData: UnifiedLeadInsertIntentionActionRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UnifiedLeadInsertIntentionActionRequestWebDto, void>(
    {
      endpoint: RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
